import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FadeUp, SectionTag } from "./Reveal";

const BG =
    "https://images.pexels.com/photos/34853016/pexels-photo-34853016.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const Community = () => (
    <section id="community" className="relative py-24 sm:py-36 overflow-hidden">
        <div className="absolute inset-0">
            <img
                src={BG}
                alt="City district at night"
                loading="lazy"
                className="w-full h-full object-cover img-treatment opacity-25"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-[#050507] via-black/70 to-[#050507]" />
        </div>

        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 text-center">
            <div className="flex justify-center">
                <SectionTag index="06" label="Community" />
            </div>

            <FadeUp>
                <h2
                    data-testid="community-heading"
                    className="font-serif-accent italic text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.1] max-w-3xl mx-auto"
                >
                    Be there when the
                    <br />
                    lights come on.
                </h2>
            </FadeUp>

            <FadeUp delay={0.12}>
                <p className="mt-8 max-w-xl mx-auto text-base sm:text-lg text-slate-300 leading-relaxed">
                    Follow WRLDKIND Studios for development updates, announcements, and the
                    first chances to take part in the project's future. The world will be
                    shaped by its earliest citizens.
                </p>
            </FadeUp>

            <FadeUp delay={0.22}>
                <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
                    <a
                        data-testid="community-x-link"
                        href="https://x.com/WRLDKINDStudios"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-3 bg-white text-black font-mono-meta text-[11px] tracking-[0.25em] uppercase px-8 py-4 hover:bg-[#A855F7] hover:text-white transition-colors duration-300"
                    >
                        <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 fill-current" aria-hidden="true">
                            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                        </svg>
                        @WRLDKINDStudios
                    </a>
                    <Link
                        to="/kickstarter"
                        data-testid="community-kickstarter-link"
                        className="inline-flex items-center gap-3 border border-[#A855F7]/50 text-white font-mono-meta text-[11px] tracking-[0.25em] uppercase px-8 py-4 hover:border-[#A855F7] hover:bg-[#A855F7]/10 transition-colors duration-300"
                    >
                        Kickstarter
                        <ArrowUpRight className="w-3.5 h-3.5 text-[#A855F7]" />
                    </Link>
                </div>
            </FadeUp>
        </div>
    </section>
);
